import PropTypes from 'prop-types';
import React from 'react';

import styles from './styles.module.less';

const propTypes = {
  children: PropTypes.string,
};

const MentionPill = ({ children }) => {
  return <div className={styles.mention}>{children}</div>;
};

MentionPill.propTypes = propTypes;

export default MentionPill;
